import { useMeeting } from "@videosdk.live/react-sdk";
import { PoweroffOutlined } from "@ant-design/icons";
import { App, Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import useFeedback from "../../../../hooks/useFeedback";

const LeaveButton = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const { leave } = useMeeting();
  const { handleFeedback } = useFeedback();

  return (
    <Tooltip title={t("video.leaveButton")}>
      <Button
        type="primary"
        size="large"
        icon={<PoweroffOutlined />}
        onClick={() => {
          message.info(t("video.leftMeetingMessage"));
          leave();
          handleFeedback();
        }}
        danger
      />
    </Tooltip>
  );
};

export default LeaveButton;
